export const Themes = {
    primary: {
        default: "#009DFF",
        focus: "#1E90FF" || "dodgerblue",
        hover: "#0083D4"
    },
    error: {
        default: "#D92C2C",
        focus: "#C51818",
        hover: "#BB0E0E"
    },
    alert: {
        default: "#FFCC00",
        hover: "#f3b005",
    },
    disabled: {
        default: "#00000042",
        hover: "#AAAAAA",
    },
    background: "#edf0f2",
    cancel: "#fefefe",
    gray: "#9b9b9b",
    darkgray: "#626262",
    black: "#000",
    white: "#fff",
    blue: "#24A9FB",
    darkblue: "#0861AA",
};